import React, { useContext } from 'react'
import { IterationContext } from '../../contexts/IterationContext';
import IterationCondition from './IterationConditions';
import Button from 'Components/DesignSystem/Button/Button';

/**
 * Dark pass + § 4.5 buttons (2026-09-08): every visible text node carries explicit
 * ink (un-inked text renders UA BLACK in dark — the dark body rule sets background
 * only), and the bottom Add Condition is a DS `Button` `secondary` (was a
 * hand-rolled `tw-border-[#091CAA]` outline whose `hover:tw-bg-blue-50` never
 * compiled). `addCondition` wiring unchanged.
 */
const MatchingConditions: React.FC = () => {
    const { iterationPayload, addCondition, activeIterationId } = useContext(IterationContext);
    const currentIteration = iterationPayload?.iterations.find(
        iteration => iteration.id === activeIterationId
    );

    if (!iterationPayload || !activeIterationId) {
        return <div className='tw-text-ink-secondary'>No data available</div>;
    }

    if (!currentIteration) {
        return <div className='tw-pb-4 tw-pl-2 tw-text-ink-secondary'>Iteration not found</div>;
    }

    const handleAddCondition = () => {
        if (activeIterationId) {
            addCondition(activeIterationId);
        }
    };

    return (
        <div className="tw-mt-4">
            <div className="tw-justify-start tw-text-ink-secondary tw-text-sm tw-font-medium tw-ps-2.5 tw-pb-4">
                Iteration {currentIteration.name}
            </div>

            <IterationCondition />

            <div className="tw-mt-6 tw-mb-4 tw-ml-8">
                <Button
                    variant="secondary"
                    onClick={handleAddCondition}
                    data-testid="add-top-level-condition"
                >
                    Add Condition
                </Button>
            </div>
        </div>
    );
};

export default MatchingConditions;
